import Component from '../core/Component'
import EventRoomBubble from './EventRoomBubble'
import Scroll from '../services/Scroll'

export default class EventRoom extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            names: [],
            bubble: null
        }

        this.index = null
    }

    prepare() {
        if (this.ref.bubble) {
            this.bubble = new EventRoomBubble(this.ref.bubble)
            this.bubble.prepare()
        }

        if (this.ref.names.length > 0) {
            this.cellWidth = this.ref.names[0].offsetWidth
            this.ref.names.forEach(name => name.addEventListener('mouseenter', this.handleMouseEnter))
            this.ref.names.forEach(name => name.addEventListener('click', this.handleClick))
            this.ref.names.forEach(name => name.addEventListener('mouseleave', this.handleMouseLeave))
            Scroll.on('scroll', this.handleScroll)
        }
    }

    destroy() {
        this.bubble?.destroy()
    }

    handleMouseEnter = event => {
        const element = event.target
        this.index = this.ref.names.findIndex(name => name === element)
        this.bubble.setImageSrc(element.dataset.imageSrc)
        this.bubble.show()
        this.bubble.setPosition(this.getBubblePosition())
        this.bubbleShowTimer = setTimeout(() => {
            this.bubbleShowTimer = null
        }, 1000)
    }

    handleMouseLeave = event => {
        this.bubble.hide()
    }

    handleClick = event => {
        const element = event.target
        this.index = this.ref.names.findIndex(name => name === element)
        this.bubble.setImageSrc(element.dataset.imageSrc)
        this.bubble.show()
        this.bubble.setPosition(this.getBubblePosition())
    }

    handleScroll = () => {
        if (this.bubbleShowTimer) {
            return
        }

        this.bubble.hide()
    }

    getBubblePosition() {
        const offsetTop = this.ref.names[this.index].offsetTop
        const offsetLeft = this.ref.names[this.index].offsetLeft
        const nameRect = this.ref.names[this.index].getBoundingClientRect()
        const bubbleRect = this.bubble.getRect()

        let nameHeight = 0

        let isBottom = false
        let isLeft = false

        if (nameRect.top < bubbleRect.height) {
            nameHeight += nameRect.height
            isBottom = true
        }

        if (nameRect.left < bubbleRect.width/2) {
            isLeft = true
        }

        return {
            x: offsetLeft,
            y: offsetTop + nameHeight,
            isBottom,
            isLeft
        }
    }

}